import React from "react";
import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";

const Modal = ({ isOpen, onClose, children, width = "lg" }) => {
  if (!isOpen) return null;

  // Configuration des largeurs disponibles
  const widthClasses = {
    sm: "sm:max-w-sm",
    md: "sm:max-w-md",
    lg: "sm:max-w-lg",
    xl: "sm:max-w-xl",
    "2xl": "sm:max-w-2xl",
    "3xl": "sm:max-w-3xl",
    "4xl": "sm:max-w-4xl",
    full: "sm:max-w-full"
  };

  return (
      <Dialog open={isOpen} onClose={onClose} className="relative z-50">
        {/* Backdrop amélioré avec un effet de flou */}
        <DialogBackdrop
            transition
            className="fixed inset-0 bg-black/40 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <DialogPanel
                transition
                className={`
              relative
              w-full
              transform
              overflow-hidden
              rounded-xl
              bg-white
              text-left
              shadow-2xl
              transition-all
              ${widthClasses[width]}
              data-[closed]:translate-y-4
              data-[closed]:opacity-0
              data-[enter]:duration-300
              data-[leave]:duration-200
              data-[enter]:ease-out
              data-[leave]:ease-in
              data-[closed]:sm:translate-y-0
              data-[closed]:sm:scale-95
            `}
            >
              {/* Contenu principal */}
              <div className="px-6 py-5 sm:p-6">
                {children}
              </div>

            </DialogPanel>
          </div>
        </div>
      </Dialog>
  );
};

export default Modal;